const messages = {
  seasons: {
    all: "Vse sezone",
    summer: "Poletje",
    winter: "Zima",
    general: "Splošno",
  },
  offer:
    "Redno razširjamo naše <br />ponudbe za vas! <br /><br />Obvestili vas bomo o novih tečajih za usposabljanje v vaši prejeti pošti.",
  summary: {
    congratulations: "ČESTITAMO - ZAKLJUČILI STE VAŠO EKSPERTIZO O",
    participation:
      "Uspešno ste zaključili spletni trening za Transporter pnevmatike za vse sezone.",
    certificate:
      "Vaš certifikat vam bo poslan po e-pošti ali ga lahko direktno prenesete kot PDF tukaj:",
    send: "Prenesi certifikat",
  },
  online: {
    title: "Naši spletni treningi",
    desc: "Zagotovite ekspertno znanje in ob uspešnem zaključku ustreznih testov za trening vaš<br> osebni certifikat o udeležbi ter 40 dodatnih točk za premium klub prvič",
    content:
      "Odkrijte naše trenutne spletne treninge zdaj in se takoj udeležite na platformi tukaj:",
    categories: {
      title: "Spletni trening",
      description:
        "Ostanite naprej z znanjem: Zagotovite ekskluzivno ekspertizo za vas in vaš tim z našimi ponudbami usposabljanja. Bodisi naše spletne seje usposabljanja, katerim lahko direktno sodelujete na platformi, naši tečaji in praktični seminarii v Bridgestone centru za usposabljanje ali celo zunanji treningi, katerih stroške lahko zmanjšate z vašimi premium točkami.",
      general: {
        title: "Splošno",
        subtitle: "Spletni trening: Splošno",
        description:
          "Odkrijte najnovejše tehnologije, pomembne razvoje v industriji pnevmatik, nasvete za vašo prodajo in še več.",
        subdesription:
          "Zagotovite ekspertno znanje in ob uspešnem zaključku ustreznih testov usposabljanja vaš osebni certifikat o udeležbi ter enkraten bonus 40 dodatnih točk za premium klub.",
      },
      product: {
        title: "Izdelki",
        subtitle: "Spletni trening: Izdelki",
        description:
          "Poglabljajte vašo Bridgestone in Firestone ekspertizo o izdelkih za uspešno prodajo z našimi kompaktnimi video usposabljanji.",
        subdesription:
          "Zagotovite ekspertno znanje in ob uspešnem zaključku ustreznih testov usposabljanja vaš osebni certifikat o udeležbi ter enkraten bonus 40 dodatnih točk za premium klub.",
      },
    },
  },
  lectures: {
    title: "Bridgestone treningi",
    desc: "Razširite vašo ekspertizo in rezervirajte naše treninge ter intenzivne treninge za vas in vaš tim. Imate možnost sodelovanja v treningih v Bridgestone centru za kompetence in usposabljanje v Dietzenbachu (blizu Frankfurta na Majni) ali, za izbrane treninge, da se izvajajo v vašem podjetju. Lahko uporabite vaše bonus točke za treninge in tako pokrijete stroške v celoti ali delno z vašimi točkami.",
    content: "Odkrijte naše trenutne treninge zdaj in zahtevajte rezervacijo:",
  },
  singleLecture: {
    registerForm: {
      title: "Vsebina treninga",
      inquiry: "Poizvedba",
      interested: "Zainteresiran sem za trening",
      participantsNr: "Število udeležencev",
      pointsFromBalance: "Želim uporabiti točke iz mojega stanja točk.",
      reduction: "To ustreza zmanjšanju stroškov za {points} evrov.",
      request: "Pošlji poizvedbo",
    },
    success: {
      thanks: "Hvala",
      title: "Vaša poizvedba je bila poslana timu za usposabljanje.",
      feedbackTime:
        "Prejeli boste odgovor v 14 dneh za pojasnitev vseh podrobnosti.",
      points:
        "Uporabljene bonus točke v znesku<br /><strong>{points}</strong> točk so bile odštete z vašega<br />računa točk.",
      refund:
        "Če trening ne bo izveden, bodo točke seveda vračene na vaš račun.",
      queries: "Za vprašanja, prosimo kontaktirajte:",
    },
    index: {
      costs: "Stroški in informacije o udeležbi",
      duration: "Trajanje: {duration}",
      cost: "Stroški {cost}: {price} evrov",
      participantsNr: "Udeleženci: min. {min} - max. {max} ljudi",
    },
  },
  index: {
    title: "Usposabljanje in izobraževanje",
    desc: "Prednost z znanjem: Zagotovite ekskluzivno strokovno znanje za vas in vaš tim z našimi ponudbami usposabljanja. Bodisi z našim spletnim usposabljanjem, kateremu lahko direktno sodelujete na platformi, z našim usposabljanjem in praktičnimi seminarii v Bridgestone centru za usposabljanje ali z zunanjim usposabljanjem, katerih stroške lahko zmanjšate z vašimi nagradnimi točkami.",
    online: {
      title: "Spletni treningi",
      desc: "Sodelujte direktno na platformi in zagotovite {points} točk za premium klub.",
    },
    lectures: {
      title: "Treningi",
      desc: "Visokokakovostni treningi v našem centru za usposabljanje ali na vaši lokaciji.",
    },
    external: {
      title: "Zunanji treningi",
      desc: "Uporabite bonus točke za ponudbe tretjih oseb in zmanjšajte stroške.",
    },
  },
  single: {
    done: "Usposabljanje zakljuceno.",
    doneDownloadCertificate: "Usposabljanje zakljuceno. Prenesi certifikat.",
  },
  certificate: {
    header: "CERTIFIKAT",
    atCourse: "je uspešno sodeloval/a v",
    takePart: "tečaju.",
    contains: "KOMPONENTE TEČAJA",
    country: "Velika Britanija",
  },
};

export default {
  messages,
};
